import { render, staticRenderFns } from "./stampDuty.vue?vue&type=template&id=4b7c8f03&scoped=true&"
import script from "./stampDuty.vue?vue&type=script&lang=js&"
export * from "./stampDuty.vue?vue&type=script&lang=js&"
import style0 from "./stampDuty.vue?vue&type=style&index=0&id=4b7c8f03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c8f03",
  null
  
)

export default component.exports